import { CoreUserMessage, UserContent } from "ai";
import { z } from "zod";
import {
  filePartSchema,
  imagePartSchema,
  textPartSchema,
} from "./core-message-part";

export const coreUserContentSchema = z.union([
  z.string(),
  z.array(z.union([textPartSchema, imagePartSchema, filePartSchema])),
]) satisfies z.ZodType<UserContent>;

export type CoreUserContentType = z.infer<typeof coreUserContentSchema>;

export const coreUserMessageSchema = z.object({
  role: z.literal("user"),
  content: coreUserContentSchema,
}) satisfies z.ZodType<CoreUserMessage>;

export const redoCoreUserMessageSchema = coreUserMessageSchema.and(
  z.object({ id: z.string() }),
);

export type RedoCoreUserMessageType = z.infer<typeof redoCoreUserMessageSchema>;
